import classNames from 'classnames';
import React from 'react';
import { useIntl } from 'react-intl';
import { LeftArrow } from '../../../../../atoms/icons/arrow/LeftArrow';

import css from './BooksStep.module.scss';

interface Props {
  allSteps: StepItems[];
  current: number;
  onRequestBack: () => void;
}

const getCss = (current: number, index: number) => {
  const currentStyle = classNames(css.BooksStep__Item, css.isCurrent);
  const doneStyle = classNames(css.BooksStep__Item, css.isDone);
  const defaultStyle = classNames(css.BooksStep__Item);

  if (current === index) {
    return currentStyle;
  } else if (current > index) {
    return doneStyle;
  }
  return defaultStyle;
};

export enum StepItems {
  Booking = 'booking',
  SelectDate = 'selectDate',
  Customer = 'customer',
  Payment = 'payment',
  Confirmation = 'confirmation',
}

export interface BookStepSetting {
  displayProgress: boolean;
  currentProgress: StepItems | null;
  renderFn: () => JSX.Element | undefined;
}

export type BookStepSettingPair = [StepItems[], BookStepSetting | undefined];

const BooksStep = ({ allSteps, current, onRequestBack }: Props) => {
  const intl = useIntl();
  const steps = allSteps.map((step, i) => ({
    css: getCss(current, i + 1), // NOTE: step starts with 1, in ModelTypeCourse.tsx
    label: `books.steps.${step}`,
  }));

  return (
    <div className={css.container}>
      {current !== 1 && (
        <div className={css.ml_8px}>
          <button onClick={onRequestBack} className={css.icon_button}>
            <LeftArrow />
          </button>
        </div>
      )}
      <div className={css.book_step_flex_item}>
        <ul className={css.BooksStepWrapper}>
          {steps.map((step, index) => (
            <li key={step.label} className={step.css}>
              <span className={css.BooksStep__StepNumber}>{index + 1}</span>
              <span className={css.BooksStep__StepLabel}>
                {intl.formatMessage({ id: step.label })}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default BooksStep;
